import { NgModule } from "@angular/core";
import { CommonModule, DatePipe, Location } from "@angular/common";
import { MaterialModule } from "./material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { DropDownComponent } from "./drop-down/drop-down.component";
import { AsteriskDirective } from "./directives/asterisk.directive";
import { InputFieldComponent } from "./input-field/input-field.component";
import { LogInPageComponent } from "./log-in-page/log-in-page.component";
import { TabsComponent } from "./tabs/tabs.component";
import { ChipsComponent } from "./chips/chips.component";
import { AsideSectionComponent } from "./aside-section/aside-section.component";
import { HeaderSectionComponent } from "./header-section/header-section.component";
import { FooterSectionComponent } from "./footer-section/footer-section.component";
import { RouterModule } from "@angular/router";
import { ToastrModule } from "ngx-toastr";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { mobiOfficeUIReducer } from "./state-management/mobi-office-ui.interface";
import { DynamicMatColumnsComponent } from "./dynamic-mat-columns/dynamic-mat-columns.component";
import { RemoveTrailingZerosPipe } from "./pipes/remove-trailing-zeros.pipe";
import { SanitizerPipe } from "./pipes/sanitizer.pipe";
import { TimeAgoPipe } from "./pipes/time-ago.pipe";
import { TableRowPipe } from "./pipes/table-row.pipe";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NotificationComponent } from "./notification/notification.component";
import { AsteriskMessageDirective } from "./directives/asterisk-message.directive";
import { CustomIfDirective } from "./directives/customIf.directive";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { ConfirmationDialogComponent } from "./confirmation-dialog/confirmation-dialog.component";
import { DynamicDialogComponent } from "./dynamic-dialog/dynamic-dialog.component";
import { MobiOfficeUIEffect } from "./state-management/mobi-office-ui.effect";
import { LoaderComponent } from "./loader/loader.component";
import { FileSizePipe } from "./pipes/filesize.pipe";
import { DynamicTableDialogComponent } from "./dynamic-table-dialog/dynamic-table-dialog.component";
import { DynamicTableComponent } from "./dynamic-table/dynamic-table.component";
import { TotalTableColumnsComponent } from "./total-table-columns/total-table-columns.component";
import { BackArrowComponent } from "./back-arrow/back-arrow.component";
import { ApplicationSwitchDrawerComponent } from "./application-switch-drawer/application-switch-drawer.component";
import { DocumentViewerComponent } from "./document-viewer/document-viewer.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { UserInfoSettingComponent } from "./header-section/user-info-setting/user-info-setting.component";
import { TimePeriodBarComponent } from "./time-period-bar/time-period-bar.component";
import { TableSkeletonComponent } from "./table-skeleton/table-skeleton.component";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { NgxImageZoomModule } from "ngx-image-zoom";
import { DateToTimeAgo } from "./pipes/date-time-ago.pipe";
import { InputBoxComponent } from "./components/input-box/input-box.component";

const PRIVATE_COMPONENTS = [ConfirmationDialogComponent, DynamicDialogComponent, DynamicTableDialogComponent, TotalTableColumnsComponent, DocumentViewerComponent, UserInfoSettingComponent];
const SHARED_COMPONENTS = [
  AsteriskDirective,
  DropDownComponent,
  InputFieldComponent,
  LogInPageComponent,
  TabsComponent,
  ChipsComponent,
  AsideSectionComponent,
  HeaderSectionComponent,
  FooterSectionComponent,
  DynamicMatColumnsComponent,
  NotificationComponent,
  FileUploadComponent,
  LoaderComponent,
  DynamicTableComponent,
  BackArrowComponent,
  ApplicationSwitchDrawerComponent,
  TimePeriodBarComponent,
  TableSkeletonComponent,
];

const PRIVATE_DIRECTIVES = [];
const SHARED_DIRECTIVES = [AsteriskMessageDirective, AsteriskDirective, CustomIfDirective];

const PRIVATE_PIPES = [TableRowPipe, FileSizePipe];
const SHARED_PIPES = [RemoveTrailingZerosPipe, SanitizerPipe, TimeAgoPipe];

@NgModule({
  declarations: [...SHARED_COMPONENTS, ...SHARED_PIPES, ...PRIVATE_PIPES, ...SHARED_DIRECTIVES, ...PRIVATE_COMPONENTS],
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    MaterialModule,
    NgbModule,
    PdfViewerModule,
    RouterModule,
    ReactiveFormsModule,
    ToastrModule,
    NgxSkeletonLoaderModule,
    StoreModule.forFeature("MOBIOFFICE_UI", mobiOfficeUIReducer),
    EffectsModule.forFeature(MobiOfficeUIEffect),
    InputBoxComponent,
    NgxImageZoomModule,
    DateToTimeAgo,
  ],
  exports: [...SHARED_COMPONENTS, ...SHARED_PIPES, ...SHARED_DIRECTIVES, NgbModule, NgxSkeletonLoaderModule, InputBoxComponent, DateToTimeAgo],
  providers: [DatePipe, Location],
})
export class MobiOfficeUiModule {}
